var debugMode = true
const strokeOrder = [
  {
    title: 'あざらし',
    discription: '',
    srcList: [
      'large_a',
      'large_za',
      'large_ra',
      'large_shi'
    ]
  },
  {
    title: 'あひる',
    srcList: [
      'large_a',
      'large_hi',
      'large_ru'
    ]
  },
  {
    title: 'あり',
    srcList: [
      'large_a',
      'large_ri'
    ]
  },
  {
    title: 'あるぱか',
    srcList: [
      'large_a',
      'large_ru',
      'large_pa',
      'large_ka'
    ]
  },
  {
    title: 'いか',
    srcList: [
      'large_i',
      'large_ka'
    ]
  },
  {
    title: 'いぐあな',
    srcList: [
      'large_i',
      'large_gu',
      'large_a',
      'large_na'
    ]
  },
  {
    title: 'いぬ',
    srcList: [
      'large_i',
      'large_nu'
    ]
  },
  {
    title: 'いのしし',
    srcList: [
      'large_i',
      'large_no',
      'large_shi',
      'large_shi'
    ]
  },
  {
    title: 'いるか',
    srcList: [
      'large_i',
      'large_ru',
      'large_ka'
    ]
  },
  {
    title: 'うさぎ',
    srcList: [
      'large_u',
      'large_sa',
      'large_gi'
    ]
  },
  {
    title: 'うし',
    srcList: [
      'large_u',
      'large_shi'
    ]
  },
  {
    title: 'うま',
    srcList: [
      'large_u',
      'large_ma'
    ]
  },
  {
    title: 'うみがめ',
    srcList: [
      'large_u',
      'large_mi',
      'large_ga',
      'large_me'
    ]
  },
  {
    title: 'おうむ',
    srcList: [
      'large_o',
      'large_u',
      'large_mu'
    ]
  },
  {
    title: 'おおかみ',
    srcList: [
      'large_o',
      'large_o',
      'large_ka',
      'large_mi'
    ]
  },
  {
    title: 'かえる',
    srcList: [
      'large_ka',
      'large_e',
      'large_ru'
    ]
  },
  {
    title: 'がぜる',
    srcList: [
      'large_ga',
      'large_ze',
      'large_ru'
    ]
  },
  {
    title: 'かたつむり',
    srcList: [
      'large_ka',
      'large_ta',
      'large_tsu',
      'large_mu',
      'large_ri'
    ]
  },
  {
    title: 'かに',
    srcList: [
      'large_ka',
      'large_ni'
    ]
  },
  {
    title: 'かば',
    srcList: [
      'large_ka',
      'large_ba'
    ]
  },
  {
    title: 'かまきり',
    srcList: [
      'large_ka',
      'large_ma',
      'large_ki',
      'large_ri'
    ]
  },
  {
    title: 'かめ',
    srcList: [
      'large_ka',
      'large_me'
    ]
  },
  {
    title: 'かめむし',
    srcList: [
      'large_ka',
      'large_me',
      'large_mu',
      'large_shi'
    ]
  },
  {
    title: 'かめれおん',
    srcList: [
      'large_ka',
      'large_me',
      'large_re',
      'large_o',
      'large_nn'
    ]
  },
  {
    title: 'からす',
    srcList: [
      'large_ka',
      'large_ra',
      'large_su'
    ]
  },
  {
    title: 'かわせみ',
    srcList: [
      'large_ka',
      'large_wa',
      'large_se',
      'large_mi'
    ]
  },
  {
    title: 'かんがるー',
    srcList: [
      'large_ka',
      'large_nn',
      'large_ga',
      'large_ru',
      'hyphen'
    ]
  },
  {
    title: 'きつつき',
    srcList: [
      'large_ki',
      'large_tsu',
      'large_tsu',
      'large_ki'
    ]
  },
  {
    title: 'きつね',
    srcList: [
      'large_ki',
      'large_tsu',
      'large_ne'
    ]
  },
  {
    title: 'きりん',
    srcList: [
      'large_ki',
      'large_ri',
      'large_nn'
    ]
  },
  {
    title: 'きんぎょ',
    srcList: [
      'large_ki',
      'large_nn',
      'large_gi',
      'small_yo'
    ]
  },
  {
    title: 'くじゃく',
    srcList: [
      'large_ku',
      'large_zi',
      'small_ya',
      'large_ku'
    ]
  },
  {
    title: 'くじら',
    srcList: [
      'large_ku',
      'large_zi',
      'large_ra'
    ]
  },
  {
    title: 'くま',
    srcList: [
      'large_ku',
      'large_ma'
    ]
  },
  {
    title: 'くも',
    srcList: [
      'large_ku',
      'large_mo'
    ]
  },
  {
    title: 'くらげ',
    srcList: [
      'large_ku',
      'large_ra',
      'large_ge'
    ]
  },
  {
    title: 'こあら',
    srcList: [
      'large_ko',
      'large_a',
      'large_ra'
    ]
  },
  {
    title: 'こい',
    srcList: [
      'large_ko',
      'large_i'
    ]
  },
  {
    title: 'こうもり',
    srcList: [
      'large_ko',
      'large_u',
      'large_mo',
      'large_ri'
    ]
  },
  {
    title: 'こよーて',
    srcList: [
      'large_ko',
      'large_yo',
      'hyphen',
      'large_te'
    ]
  },
  {
    title: 'ごりら',
    srcList: [
      'large_go',
      'large_ri',
      'large_ra'
    ]
  },
  {
    title: 'さい',
    srcList: [
      'large_sa',
      'large_i'
    ]
  },
  {
    title: 'さそり',
    srcList: [
      'large_sa',
      'large_so',
      'large_ri'
    ]
  },
  {
    title: 'さめ',
    srcList: [
      'large_sa',
      'large_me'
    ]
  },
  {
    title: 'ざりがに',
    srcList: [
      'large_za',
      'large_ri',
      'large_ga',
      'large_ni'
    ]
  },
  {
    title: 'さる',
    srcList: [
      'large_sa',
      'large_ru'
    ]
  },
  {
    title: 'しか',
    srcList: [
      'large_shi',
      'large_ka'
    ]
  },
  {
    title: 'しまうま',
    srcList: [
      'large_shi',
      'large_ma',
      'large_u',
      'large_ma'
    ]
  },
  {
    title: 'しゃち',
    srcList: [
      'large_shi',
      'small_ya',
      'large_chi'
    ]
  },
  {
    title: 'しろくま',
    srcList: [
      'large_shi',
      'large_ro',
      'large_ku',
      'large_ma'
    ]
  },
  {
    title: 'すかんく',
    srcList: [
      'large_su',
      'large_ka',
      'large_nn',
      'large_ku'
    ]
  },
  {
    title: 'すずめ',
    srcList: [
      'large_su',
      'large_zu',
      'large_me'
    ]
  },
  {
    title: 'ぞう',
    srcList: [
      'large_zo',
      'large_u'
    ]
  },
  {
    title: 'たこ',
    srcList: [
      'large_ta',
      'large_ko'
    ]
  },
  {
    title: 'だちょう',
    srcList: [
      'large_da',
      'large_chi',
      'small_yo',
      'large_u'
    ]
  },
  {
    title: 'たぬき',
    srcList: [
      'large_ta',
      'large_nu',
      'large_ki'
    ]
  },
  {
    title: 'ちーたー',
    srcList: [
      'large_chi',
      'hyphen',
      'large_ta',
      'hyphen'
    ]
  },
  {
    title: 'ちょう',
    srcList: [
      'large_chi',
      'small_yo',
      'large_u'
    ]
  },
  {
    title: 'つばめ',
    srcList: [
      'large_tsu',
      'large_ba',
      'large_me'
    ]
  },
  {
    title: 'てんとうむし',
    srcList: [
      'large_te',
      'large_nn',
      'large_to',
      'large_u',
      'large_mu',
      'large_shi'
    ]
  },
  {
    title: 'とかげ',
    srcList: [
      'large_to',
      'large_ka',
      'large_ge'
    ]
  },
  {
    title: 'となかい',
    srcList: [
      'large_to',
      'large_na',
      'large_ka',
      'large_i'
    ]
  },
  {
    title: 'とら',
    srcList: [
      'large_to',
      'large_ra'
    ]
  },
  {
    title: 'とんぼ',
    srcList: [
      'large_to',
      'large_nn',
      'large_bo'
    ]
  },
  {
    title: 'なめくじ',
    srcList: [
      'large_na',
      'large_me',
      'large_ku',
      'large_zi'
    ]
  },
  {
    title: 'にわとり',
    srcList: [
      'large_ni',
      'large_wa',
      'large_to',
      'large_ri'
    ]
  },
  {
    title: 'ねこ',
    srcList: [
      'large_ne',
      'large_ko'
    ]
  },
  {
    title: 'ねずみ',
    srcList: [
      'large_ne',
      'large_zu',
      'large_mi'
    ]
  },
  {
    title: 'はいえな',
    srcList: [
      'large_ha',
      'large_i',
      'large_e',
      'large_na'
    ]
  },
  {
    title: 'はえ',
    srcList: [
      'large_ha',
      'large_e'
    ]
  },
  {
    title: 'はげたか',
    srcList: [
      'large_ha',
      'large_ge',
      'large_ta',
      'large_ka'
    ]
  },
  {
    title: 'はち',
    srcList: [
      'large_ha',
      'large_chi'
    ]
  },
  {
    title: 'はちどり',
    srcList: [
      'large_ha',
      'large_chi',
      'large_do',
      'large_ri'
    ]
  },
  {
    title: 'ばった',
    srcList: [
      'large_ba',
      'small_tsu',
      'large_ta'
    ]
  },
  {
    title: 'はと',
    srcList: [
      'large_ha',
      'large_to'
    ]
  },
  {
    title: 'はりねずみ',
    srcList: [
      'large_ha',
      'large_ri',
      'large_ne',
      'large_zu',
      'large_mi'
    ]
  },
  {
    title: 'ぱんだ',
    srcList: [
      'large_pa',
      'large_nn',
      'large_da'
    ]
  },
  {
    title: 'びーばー',
    srcList: [
      'large_bi',
      'hyphen',
      'large_ba',
      'hyphen'
    ]
  },
  {
    title: 'ひつじ',
    srcList: [
      'large_hi',
      'large_tsu',
      'large_zi'
    ]
  },
  {
    title: 'ひとで',
    srcList: [
      'large_hi',
      'large_to',
      'large_de'
    ]
  },
  {
    title: 'ひょう',
    srcList: [
      'large_hi',
      'small_yo',
      'large_u'
    ]
  },
  {
    title: 'ふくろう',
    srcList: [
      'large_hu',
      'large_ku',
      'large_ro',
      'large_u'
    ]
  },
  {
    title: 'ぶた',
    srcList: [
      'large_bu',
      'large_ta'
    ]
  },
  {
    title: 'へび',
    srcList: [
      'large_he',
      'large_bi'
    ]
  },
  {
    title: 'ぺりかん',
    srcList: [
      'large_pe',
      'large_ri',
      'large_ka',
      'large_nn'
    ]
  },
  {
    title: 'ぺんぎん',
    srcList: [
      'large_pe',
      'large_nn',
      'large_gi',
      'large_nn'
    ]
  },
  {
    title: 'まなてぃ',
    srcList: [
      'large_ma',
      'large_na',
      'large_te',
      'small_i'
    ]
  },
  {
    title: 'まんた',
    srcList: [
      'large_ma',
      'large_nn',
      'large_ta'
    ]
  },
  {
    title: 'みみず',
    srcList: [
      'large_mi',
      'large_mi',
      'large_zu'
    ]
  },
  {
    title: 'むかで',
    srcList: [
      'large_mu',
      'large_ka',
      'large_de'
    ]
  },
  {
    title: 'やぎ',
    srcList: [
      'large_ya',
      'large_gi'
    ]
  },
  {
    title: 'やどかり',
    srcList: [
      'large_ya',
      'large_do',
      'large_ka',
      'large_ri'
    ]
  },
  {
    title: 'らいおん',
    srcList: [
      'large_ra',
      'large_i',
      'large_o',
      'large_nn'
    ]
  },
  {
    title: 'らくだ',
    srcList: [
      'large_ra',
      'large_ku',
      'large_da'
    ]
  },
  {
    title: 'らっこ',
    srcList: [
      'large_ra',
      'small_tsu',
      'large_ko'
    ]
  },
  {
    title: 'りす',
    srcList: [
      'large_ri',
      'large_su'
    ]
  },
  {
    title: 'りんくす',
    srcList: [
      'large_ri',
      'large_nn',
      'large_ku',
      'large_su'
    ]
  },
  {
    title: 'ろば',
    srcList: [
      'large_ro',
      'large_ba'
    ]
  },
  {
    title: 'わし',
    srcList: [
      'large_wa',
      'large_shi'
    ]
  },
  {
    title: 'わに',
    srcList: [
      'large_wa',
      'large_ni'
    ]
  }
]
export default {
  name: 'utils',
  methods: {
    debug: function (msg) {
      if (debugMode) {
        console.log('DEBUG : ' + msg)
      }
    },
    info: function (msg) {
      console.log('INFO : ' + msg)
    },
    getStrokeOrder: function (num) {
      var targetStrokeOrder = strokeOrder[num - 1]
      var result = {
        hiraganaSrcList: [],
        katakanaSrcList: []
      }

      for (var id = 0; id < targetStrokeOrder.srcList.length; id++) {
        var src = targetStrokeOrder.srcList[id]

        var hiraganaItem = {}
        hiraganaItem.id = id
        hiraganaItem.src = require('@/assets/gif/hiragana_' + src + '-compressor.gif')
        result.hiraganaSrcList.push(hiraganaItem)

        var katakanaItem = {}
        katakanaItem.id = id + targetStrokeOrder.srcList.length
        katakanaItem.src = require('@/assets/gif/katakana_' + src + '-compressor.gif')
        result.katakanaSrcList.push(katakanaItem)
      }

      return result
    },
    getStrokeOrderInfo: function (num) {
      return strokeOrder[num - 1]
    },
    playAudio: function (audioSrc) {
      this.debug('playAudio : ' + audioSrc + 'の音声を呼び出しました')

      // ガーベッジコレクション制御
      var Sound = (function () {
        var df = document.createDocumentFragment()
        return function Sound (src) {
          var snd = new Audio(src)
          df.appendChild(snd)
          snd.addEventListener('ended', function () { df.removeChild(snd) })
          snd.play()
          return snd
        }
      }())
      // 音声再生
      Sound(audioSrc)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utils.js